import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_updateHeadlineCarousel, ParamsType, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_updateHeadlineCarousel';

export type HomePageCarouselModelType = Response200Type;

const decode = (status: number, data: ResponseType): HomePageCarouselModelType => {
    console.log('data ', data);
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface HomePageCarouselTypeSubmitType {
    data: ParamsType['body'],
    id: number
}

export const putUpdateHeadlineCarousel = {
    browser: {
        params: (params: HomePageCarouselTypeSubmitType): ParamsFetchType<any> => {
            return {
                type: MethodType.PUT,
                url: '/api-web/update-headline-carousel',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PUT,
        urlBrowser: '/api-web/update-headline-carousel',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<HomePageCarouselTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_updateHeadlineCarousel(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.id,
            body: params.req.body.data
        });
        console.log('response ', response);
        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
